import { render, staticRenderFns } from "./businessAnalysis-list.vue?vue&type=template&id=838cadfc&scoped=true&"
import script from "./businessAnalysis-list.vue?vue&type=script&lang=js&"
export * from "./businessAnalysis-list.vue?vue&type=script&lang=js&"
import style0 from "./businessAnalysis-list.vue?vue&type=style&index=0&id=838cadfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838cadfc",
  null
  
)

export default component.exports